import React from 'react';
import { GlobalData } from '../../../types';
import styles from './Step1.module.scss';
import { Link } from 'react-router-dom';
import { Layout } from '../../../components/common/Layout/Layout';
import { StepHeader } from '../../../components/common/StepHeader/StepHeader';
import { Campaign } from '../../../components/common/Campaign/Campaign';
import IconRightArrow from '../../../assets/img/common/icon_right_arrow.svg';
import { formatTitle } from '../utils/formatTitle';

interface Step1Props {
  data: GlobalData[];
  campaignTitle?: string;
  campaignSubtitle?: string;
}

export const Step1: React.FC<Step1Props> = ({ data, campaignTitle, campaignSubtitle }) => {
  return (
    <Layout>
      <div className={styles.step1}>
        <Campaign title={campaignTitle} subtitle={campaignSubtitle} />
        <StepHeader
          stepNumber={1}
          title="修理したいアイテムを選択してください"
          subtitle="1回のお問い合わせにつき、1アイテムでお願いいたします。"
        />
        <div className={styles.items}>
          {data.map((collectionData, index) => {
            // suits_campaignの場合は表示しない
            if (collectionData.first_collection.handle === "suits_campaign") {
              return null;
            }
            
            // 現在のURLパラメータを取得
            const currentParams = new URLSearchParams(window.location.search);
            
            // 新しいパラメータを追加
            if (collectionData.first_collection.handle === "first_other") {
              currentParams.set('step', '4');
              currentParams.set('firstcollectionhandle', 'first_other');
              currentParams.set('secondcollectionhandle', 'second_other');
              currentParams.set('producthandle', 'product_other');
            } else {
              currentParams.set('step', '2');
              currentParams.set('firstcollectionhandle', collectionData.first_collection.handle);
            }
            
            const linkPath = `/?${currentParams.toString()}`;
            const gaId = collectionData.first_collection_metafields.metafields._ga_id;
            return (
              <Link
                key={index}
                to={linkPath}
                className={`${styles.link} ${gaId ? "js-trackEvent" : ""}`}
                data-ga-id={gaId}
              >
                <h3 className={styles.itemTitle}>
                  {formatTitle(collectionData.first_collection.title)}
                </h3>
                <p className={styles.itemSubTitle}>
                  {collectionData.first_collection.body_html || ''}
                </p>
                <img
                  className={styles.itemImg}
                  src={collectionData.first_collection.image?.src}
                  alt={
                    collectionData.first_collection.image?.alt ||
                    collectionData.first_collection.title
                  }
                  width="104"
                  height="64"
                />
                <div className={styles.arrow}>
                  <IconRightArrow />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};
